import React from "react";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Stack from "@mui/material/Stack";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { useTheme } from "@mui/material/styles";

const ThreadHeader: React.FC = () => {
  const { palette } = useTheme();
  const isDark = palette.mode === 'dark';
  const handleClose = () => {
    window.close();
  };

  return (
    <AppBar
      position="static"
      color="default"
      elevation={1}
      sx={{
        borderBottom: isDark ? "1px solid #1e3a5f" : "1px solid #e0e0e0",
        backgroundColor: isDark ? "#0b1120" : "#ffffff",
      }}
    >
      <Toolbar
        sx={{
          minHeight: 56,
          px: 2,
        }}
      >
        {/* 左側：タイトルなど置きたい場合（今はスレッドヘッダーという名前） */}
        <Typography
          variant="subtitle1"
          sx={{
            flexGrow: 1,
            fontWeight: 500,
          }}
        >
          スレッド
        </Typography>

        {/* 右側：閉じるボタン */}
        <Stack
          direction="row"
          spacing={1}
        >
          <Button
            type="button"
            variant="outlined"
            size="small"
            onClick={handleClose}
            aria-label="スレッド画面を閉じる"
            sx={{
              textTransform: "none",
              fontSize: 14,
              px: 1.5,
              py: 0.5,
              minWidth: "auto",
              display: "inline-flex",
              alignItems: "center",
              gap: 0.5,
            }}
          >
            <span
              style={{
                fontSize: 16,
                lineHeight: 1,
              }}
            >
              ✕
            </span>
            <span>
              閉じる
            </span>
          </Button>
        </Stack>
      </Toolbar>
    </AppBar>
  );
};

export default ThreadHeader;
